import ReactDOM from 'react-dom';
import React from 'react';
import { IVideoGallery } from '../../../galleries/video-gallery/interfaces';
import OnlineMasteringVideoGallery from './olm-video-gallery';
import { getGdprCookie, getGdprError } from '../../../gdpr/domain/gdpr-provider';

export const initOnlineMasteringVideoGallery = () => {

    const $placeholder = document.getElementById('olm-video-gallery');
    if(!$placeholder) {
        console.error('Element with id="olm-video-gallery" is missing.');
        return;
    }

    const gdpr = getGdprCookie();
    const isFunctional = gdpr.IsFunctional;
    if(!isFunctional) {
        $placeholder.innerHTML = getGdprError();
    }

    const $data = document.getElementById('video-gallery-data');
    if(!$data) {
        console.error('Element with id="video-gallery-data" is missing.');
        return;
    }

    let data: IVideoGallery[] = [];

    try {
        data = JSON.parse($data?.textContent ?? '');
    }
    catch (ex) {
        console.error('Parse data error', ex);
        return;
    }

    if(!data?.length) {
        console.error('No videos found.');
        return;
    }

    ReactDOM.render(
        <React.StrictMode>
            <OnlineMasteringVideoGallery
                videos={ data }
            />
        </React.StrictMode>,
        $placeholder,
    );
};